export const SUPPORT_PHONE_E164 = '+19174232715';
export const SUPPORT_PHONE_DISPLAY = '917-423-2715';
export const SUPPORT_EMAIL = 'support@conduithealth.com';
